import React, { useEffect } from 'react';
import Lottie from "react-lottie";
import * as about from "./error.json"

function ErrorAnimation() {
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: about.default,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };
    return (
        <div >
        <Lottie options={defaultOptions} height={400} width={400} />
    </div>
    )
}

export default ErrorAnimation;
